import React from 'react';
import { Row } from 'react-bootstrap';
import GitHubCalendar from 'react-github-calendar';

function Github() {
  return (
    <a href="https://github.com/prasanto19" rel="noreferrer" target="_blank">
      <Row style={{ justifyContent: 'center', paddingBottom: '10px' }}>
        <h1 className="project-heading" style={{ paddingBottom: '20px' }}>
          Days I <strong className="purple">Code in Github</strong>
        </h1>
        <GitHubCalendar
          username="Prasanto19"
          blockSize={15}
          blockMargin={5}
          color="#c084f5"
          fontSize={16}
        />
      </Row>
    </a>
  );
}

export default Github;
